<template>
  <div>
    <div v-if="label" class="tw-mb-1 tw-flex tw-items-center tw-justify-between tw-text-xs dark:tw-text-white">
      <div class="tw-flex tw-items-center">
        {{ label }}
        <slot name="info" />
      </div>
      <span v-if="lengthCounter" class="tw-text-slate-400">
        {{ lengthCounter }}
      </span>
    </div>
    <textarea
      ref="textarea"
      :class="{
        'tw-block tw-min-h-[100px] tw-w-full tw-appearance-none tw-rounded-md tw-border tw-border-solid tw-bg-white tw-px-3 tw-py-2 placeholder:tw-text-slate-400 focus:tw-border-deep-orange-500 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-deep-orange-500 dark:tw-bg-slate-900 dark:tw-text-white sm:tw-text-sm': true,
        'tw-outline-red-600 dark:tw-outline-red-400': inlineError,
        'hover:tw-border-deep-orange-500 focus:tw-border-deep-orange-600 focus:tw-ring-deep-orange-500': !inlineError
      }"
      :rows="rows"
      :data-testid="id"
      :placeholder="placeholder"
      :disabled="disabled"
      :required="required"
      :value="modelValue"
      :maxlength="maxlength"
      @input="$emit('update:modelValue', $event.target.value)"
      @change="$emit('update:modelValue', $event.target.value)"
      @focus="$emit('focus', $event)"
      @blur="$emit('blur', $event)"
    />
    <div v-if="inlineError" class="tw-mt-1 tw-text-xs tw-text-red-600 dark:tw-text-red-400">
      {{ inlineError }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'StudioTextarea',
  props: {
    modelValue: {
      type: [String, Number],
      default: ''
    },
    placeholder: { type: String, default: '' },
    label: { type: String, default: '' },
    required: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    inlineError: { type: String, default: '' },
    maxlength: { type: Number, default: Infinity },
    rows: { type: Number, default: 4 },
    id: { type: String, required: true }
  },
  emits: ['update:modelValue', 'focus', 'blur'],
  computed: {
    lengthCounter() {
      if (this.modelValue && this.maxlength < Infinity) {
        return `(${this.modelValue.length}/${this.maxlength})`;
      }
      return '';
    }
  },
  methods: {
    /** @public */
    checkValidity() {
      return this.$refs.textarea.checkValidity();
    },
    /** @public */
    setCustomValidity(msg) {
      const input = this.$refs.textarea;
      input.setCustomValidity(msg);
      input.reportValidity();
    },
    /** @public */
    focus() {
      this.$refs.textarea.focus();
    }
  }
};
</script>
